<template>
<div class="container row">
    <div>
            <div>
                <div>
                        <img class="img-fluid" src="@/assets/img/localizacao2.png" alt="Localization Image">
                        <div class="text-center">
                            <h3 >Permita a sua localização?</h3>
                            <h6>Dessa forma você terá acesso aos produtos e ofertas da sua região.</h6>
                            <h3 class="mt-5">Já têm um endereço salvo?</h3>
                            <h5>Entre na sua conta para selecionar seu endereço.</h5>
                            <button class="mt-5 btn btn-success btn-lg buttonLeave" @click="hideModal(), storageModal()">Prosseguir</button>
                        </div>
                </div>
            </div>
    </div>
</div>
</template>
<script>

export default {
    
methods: {
    hideModal() {
    const cathButton = document.getElementsByClassName('buttonLeave');
    if(cathButton) {
        this.$bvModal.hide('acessModal');
    }
    },
    storageModal() {localStorage.setItem('modal', 'modalValue');},
    }
}
</script>
